import React from 'react';
import './LandingSocialProof.css';

const LandingSocialProof = () => {



    return (
        <section className="landing-social-proof">
            <p className="sp-label">L'outil indispensable pour votre compte Uncove</p>


            <div className="landing-section sp-metrics-grid">
                <div className="sp-metric-card">
                    <span className="sp-metric-value">+45h</span>
                    <span className="sp-metric-desc">Gagnées par semaine</span>
                </div>
                <div className="sp-metric-divisor"></div>
                <div className="sp-metric-card">
                    <span className="sp-metric-value">x2.2</span>
                    <span className="sp-metric-desc">Revenus moyens</span>
                </div>
                <div className="sp-metric-divisor"></div>
                <div className="sp-metric-card">
                    <span className="sp-metric-value">24/7</span>
                    <span className="sp-metric-desc">Activité garantie</span>
                </div>
            </div>
        </section>
    );
};

export default LandingSocialProof;
